import React from 'react';
import './whatsapp-icon.scss';
import useLocaleMode from '../../../hooks/useLocaleMode';
import { useStaticQuery, graphql } from 'gatsby';
// import useBrowserMode from '../../../hooks/useBrowserMode';

const WhatsappIcon = props => {

  const { locale } = useLocaleMode();
  // const { isBrowser } = useBrowserMode();
  const query = useStaticQuery(graphql`
    query WHATSAPP_NUMBER {
      allContentfulTenaHome {
        nodes {
          numeroDeWhatsApp
          node_locale
          tieneChat
        }
      }
    }`
  );

  const whatsappNumber = (query && (query.allContentfulTenaHome.nodes.filter(node => node.node_locale.includes(locale))[0]));

  return (
    <>
      {whatsappNumber && (whatsappNumber.tieneChat && (<a className="f-whatsApp-container"
        href={"https://api.whatsapp.com/send?phone=" + whatsappNumber.numeroDeWhatsApp}
        target="_blank"
        rel="noopener noreferrer"
        data-label={'Nos encantaría ayudarte, ¡conversemos!'}
      >
      </a>))}
    </>
  )
};

export default WhatsappIcon;